import validate from './validate';

const validators = {
  hasCorrectFormat: value => /^(s|S)[0-9]{6}[a-fA-F0-9]{11}$/.test(value)
};

const validatorsLive = {
  hasCorrectFormat: value => /^(s|S)[0-9]{0,5}$|^(s|S)[0-9]{6}[a-fA-F0-9]{0,11}$/.test(value)
};

const validationErrors = {
  hasCorrectFormat: 'You have entered an invalid slip number!'
};

export const checkBetSlipNumberLive = (
  betSlipNumber => validate(betSlipNumber, validatorsLive, validationErrors)
);

export const checkBetSlipNumber = (
  betSlipNumber => validate(betSlipNumber, validators, validationErrors)
);

export default checkBetSlipNumber;
